import { render, staticRenderFns } from "./EventBlastEmail.vue?vue&type=template&id=406c1564&scoped=true"
import script from "./EventBlastEmail.vue?vue&type=script&lang=js"
export * from "./EventBlastEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406c1564",
  null
  
)

export default component.exports